import { HttpClient, HttpClientModule, HttpHeaderResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { Camera } from './cameras.service';
import { User } from './users.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationsService {

  constructor(private auth: AuthService, private http: HttpClient) { }

  getOrganisations(): Observable<Organisation[]> {
    return this.http.get<Organisation[]>('https://nvr.logisys.hu:8012/organizations', { headers: new HttpHeaders({'Authorization': this.auth.token})})
  }
}

export interface Organisation {
  Felelos: User
  Camera: Camera

  camera_count: number
  user_count: number
  id: number
  can_view_stats: boolean
  dvr_limit: number
  title: string
  is_member: boolean
  can_edit_cameras: boolean
  domain: Domain
  user_limit: number
  camera_limit: number
  is_default: boolean
  owner: Owner
  mosaic_count: number
  can_edit_users: boolean
}

export interface Domain {
  id: number
  title: string
}

export interface Owner {
  login: string
  id: number
}
